module.exports = __webpack_public_path__ + "static/media/logo.2e99e86e.png";